import * as yup from "yup";

const MailApproveValidationSchema = yup.object().shape({
	email: yup
		.string()
		.required("Lütfen e-posta adresini giriniz.")
		.email("Lütfen geçerli bir e-posta adresi giriniz."),
	code: yup.string().when("isCodeSend", {
		is: true,
		then: yup
			.string()
			.required("Lütfen e-posta adresinize gönderilen kodu giriniz."),
	}),
});

export default MailApproveValidationSchema;
